// extracted by mini-css-extract-plugin
export var displayNone = "_rl-6";
export var imgContainer = "_rl-2";
export var overflowHidden = "_rl-3";
export var productInfoCardButtonContainer = "_rl-5";
export var productTitleText = "_rl-4";
export var rightArrow = "_rl-1";
export var rightArrowContainer = "_rl-0";